<template>
  <div>
    <div class="tab-content">
        <div class="tab-item" v-for="(item,index) in list" :key="index" :style="(index+1)%4!=0?'margin-right:40px':''">
            <defaultImg :src="item.src"></defaultImg>
            <div class="title">{{item.title}}</div>
        </div>
    </div>
    <div class="pagination mg-top40">
        <el-pagination
            background
            layout="prev, pager, next, jumper"
            :total="dataList.total"
            :page-size="params.pageSize"
            @current-change="handleCurrentChange">
        </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tabContent',
  props:{
    dataList:{
        default:()=>{},
        type: Object
    }
  },
  data () {
    return {
      list:[],
      params:{
        pageNum:1,
        pageSize:8
      }
    }
  },
  methods: {
    handleCurrentChange(page){
      this.list = this.dataList.list.slice((page-1)*8,page*8)
    }
  },
  watch:{
    'dataList':{
      handler(newVal,oldVal){
        this.list = newVal.list.slice(0,8)
      },
      immediate: true
    }
  }
}
</script> 

<style lang='less' scoped>
.tab-content{
    overflow: hidden;
    .tab-item{
        margin-bottom: 40px;
        float: left;
        img{
            width: 330px;
            height: 220px;
        }
        .title{
            width: 330px;
            height: 50px;
            line-height: 50px;
            text-align: center;
            background-color: #F2F2F2;
            color: #333333;
            font-size: 16px;
        }
    }
}
</style>
